<template>
  <div class="FotoalbumCard">
    <b-card :id="`fotoalbum-${fotoalbum.id}`"  class="FotoalbumCard" border-variant="danger" no-body>
      <b-card-header header-bg-variant="danger" class="text-white text-left p-1">
        <b-card-title class="my-1">{{ fotoalbum.titel }} <font-awesome-icon icon="cog" class=" float-right grow" @click="$bvModal.show(`update-${fotoalbum.id}`)"/></b-card-title>
      </b-card-header>
      <b-card-body class="p-1" @click="$bvModal.show(`img-show-${fotoalbum.id}`)">
        <img v-if="fotoalbum.fotos && fotoalbum.fotos[0].image " class="fotoalbumCardImg" :src="`data:${fotoalbum.fotos[0].contentType};base64,${fotoalbum.fotos[0].image}`" />
      </b-card-body>
    </b-card>

    <b-modal :id="`img-show-${fotoalbum.id}`" size="xl" header-bg-variant="danger" header-text-variant="white" hide-footer>
      <template v-slot:modal-title>{{ fotoalbum.titel }}</template>
      <div class="slider-margin">
        <ImageSlider :fotoalbum="fotoalbum" />
      </div>
    </b-modal>

    <b-modal :id="`update-${fotoalbum.id}`" size="xl" header-bg-variant="danger" header-text-variant="white" hide-footer>
      <template v-slot:modal-title>{{ fotoalbum.titel }}</template>
      <b-button variant="danger" @click="remFotoalbum(fotoalbum.id)" class="mr-3">Löschen</b-button>
      <b-button variant="secondary" @click="$bvModal.hide(`update-${fotoalbum.id}`)">Abbrechen</b-button>
    </b-modal>
  </div>
</template>

<script>
import ImageSlider from './ImageSlider'
import { mapGetters, mapActions } from 'vuex'


export default {
  name: 'FotoalbumCard',
  components: {
    ImageSlider
  },
  props: ['fotoalbum'],
  computed: mapGetters(['fotoalbumStatus']),
  methods: {
    ...mapActions(['removeFotoalbum', 'getFotoalbumBild']),
    remFotoalbum (fotoalbumId) {
      if(confirm("Soll das Fotoalbum wirklich gelöscht werden?")) {
        this.removeFotoalbum(fotoalbumId)
          .then(() => {
            const toastData = {
            title: "",
            msg: "Das Fotoalbum wurde gelöscht.",
            variant: "success"
            }

            if (this.fotoalbumStatus.errMsg) {
              toastData.title = "Es ist etwas schief gelaufen.";
              toastData.msg = this.fotoalbumStatus.errMsg;
              toastData.variant = "danger";
            }

            this.makeToast(toastData)

            if (!this.fotoalbumStatus.errMsg) {
              this.$bvModal.hide(`update-${this.fotoalbum.id}`);
            }
          })
      }
    },
    getFotoalbumPreviewBild () {
      const data = {
        fotoalbumId: this.fotoalbum.id,
        filename: this.fotoalbum.fotos[0].titel
      }
      this.getFotoalbumBild(data)
    },
    makeToast (toast) {
      this.$bvToast.toast(toast.msg, {
        title: toast.title,
        toaster: 'b-toaster-bottom-full',
        variant: toast.variant,
        autoHideDelay: 7000,
        appendToast: true,
        solid: true
      })
    }
  },
  mounted () {
    this.getFotoalbumPreviewBild()
  }
}
</script>

<style scoped>
.FotoalbumCard {
  height: 100%;
  max-height: 20rem;
  box-shadow: 0px 0px 4px #1a1a1a;
}

.fotoalbumCardImg {
  width: 100%;
  max-height: 15rem;
  overflow: hidden;
  object-fit: cover;
}

.slider-margin {
  margin: -1rem
}

.grow {
  transition: all .2s ease-in-out;
}

.grow:hover {
  cursor: pointer;
  transform: scale(1.1);
}
</style>